/**
 * get selected value, use with BaseDropDown components
 * @param {*} selectedValue
 * @param {*} options
 */
export const getSelectedValue = (selectedValue = null, options = []) => {
	const values = Object.values(options);
	const findValue = ({ value }) => value === selectedValue;
	return values.find(findValue) || { name: null, value: null };
};